/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Freegamesitemdesc3Inputs */

const id_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi penawaran game gratis terbaru di Epic Games Store.`)
};

const ms_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai tawaran permainan percuma terkini di Epic Games Store.`)
};

const da_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk de seneste gratis spil på Epic Games Store.`)
};

const de_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken Sie die neuesten kostenlosen Spiele im Epic Games Store.`)
};

const en_us2_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the latest free game offerings on the Epic Games Store.`)
};

const es_es2_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora los últimos juegos gratuitos de la Epic Games Store.`)
};

const es_mx2_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora las últimas ofertas de juegos gratis en la Epic Games Store.`)
};

const fil_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuklasin ang mga pinakabagong libreng laro sa Epic Games Store.`)
};

const fr_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez les dernières offres de jeux gratuits sur l'Epic Games Store.`)
};

const it_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora le ultime offerte di giochi gratuiti sull'Epic Games Store.`)
};

const hu_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedezd fel a legújabb ingyenes játékokat az Epic Games Store-ban.`)
};

const nl_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek de nieuwste gratis game-aanbiedingen in de Epic Games Store.`)
};

const no_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk de nyeste gratisspillene på Epic Games Store.`)
};

const pl_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkryj najnowsze darmowe gry w Epic Games Store.`)
};

const pt_br2_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore os jogos grátis mais recentes da Epic Games Store.`)
};

const pt_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore as últimas ofertas de jogos grátis na Epic Games Store.`)
};

const ro_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorează cele mai recente jocuri gratuite pe Epic Games Store.`)
};

const fi_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutustu uusimpiin ilmaisiin peleihin Epic Games Storessa.`)
};

const sv_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska de senaste gratisspelen i Epic Games Store.`)
};

const vi_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá các game miễn phí mới nhất trên Epic Games Store.`)
};

const tr_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki en son ücretsiz oyun tekliflerini keşfedin.`)
};

const cs_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumejte nejnovější nabídky her zdarma na Epic Games Store.`)
};

const bg_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разгледайте най-новите безплатни игри в Epic Games Store.`)
};

const ru_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучите последние бесплатные предложения игр в Epic Games Store.`)
};

const uk_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перегляньте останні безкоштовні ігри в Epic Games Store.`)
};

const ar_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استعرض أحدث العروض المجانية في Epic Games Store.`)
};

const hi_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store पर नवीनतम मुफ़्त गेम ऑफ़र देखें।`)
};

const th_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำรวจเกมฟรีล่าสุดบน Epic Games Store`)
};

const ja_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store の最新無料ゲームをチェック。`)
};

const zh_cn2_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索Epic游戏商城最新的免费游戏赠送。`)
};

const zh_hant1_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索Epic遊戲商城最新的免費遊戲贈送。`)
};

const ko_nav_freegamesitemdesc3 = /** @type {(inputs: Nav_Freegamesitemdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 최신 무료 게임을 살펴보세요.`)
};

/**
* | output |
* | --- |
* | "Explore the latest free game offerings on the Epic Games Store." |
*
* @param {Nav_Freegamesitemdesc3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_freegamesitemdesc3 = /** @type {((inputs?: Nav_Freegamesitemdesc3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Freegamesitemdesc3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_freegamesitemdesc3(inputs)
	if (locale === "ms") return ms_nav_freegamesitemdesc3(inputs)
	if (locale === "da") return da_nav_freegamesitemdesc3(inputs)
	if (locale === "de") return de_nav_freegamesitemdesc3(inputs)
	if (locale === "en-US") return en_us2_nav_freegamesitemdesc3(inputs)
	if (locale === "es-ES") return es_es2_nav_freegamesitemdesc3(inputs)
	if (locale === "es-MX") return es_mx2_nav_freegamesitemdesc3(inputs)
	if (locale === "fil") return fil_nav_freegamesitemdesc3(inputs)
	if (locale === "fr") return fr_nav_freegamesitemdesc3(inputs)
	if (locale === "it") return it_nav_freegamesitemdesc3(inputs)
	if (locale === "hu") return hu_nav_freegamesitemdesc3(inputs)
	if (locale === "nl") return nl_nav_freegamesitemdesc3(inputs)
	if (locale === "no") return no_nav_freegamesitemdesc3(inputs)
	if (locale === "pl") return pl_nav_freegamesitemdesc3(inputs)
	if (locale === "pt-BR") return pt_br2_nav_freegamesitemdesc3(inputs)
	if (locale === "pt") return pt_nav_freegamesitemdesc3(inputs)
	if (locale === "ro") return ro_nav_freegamesitemdesc3(inputs)
	if (locale === "fi") return fi_nav_freegamesitemdesc3(inputs)
	if (locale === "sv") return sv_nav_freegamesitemdesc3(inputs)
	if (locale === "vi") return vi_nav_freegamesitemdesc3(inputs)
	if (locale === "tr") return tr_nav_freegamesitemdesc3(inputs)
	if (locale === "cs") return cs_nav_freegamesitemdesc3(inputs)
	if (locale === "bg") return bg_nav_freegamesitemdesc3(inputs)
	if (locale === "ru") return ru_nav_freegamesitemdesc3(inputs)
	if (locale === "uk") return uk_nav_freegamesitemdesc3(inputs)
	if (locale === "ar") return ar_nav_freegamesitemdesc3(inputs)
	if (locale === "hi") return hi_nav_freegamesitemdesc3(inputs)
	if (locale === "th") return th_nav_freegamesitemdesc3(inputs)
	if (locale === "ja") return ja_nav_freegamesitemdesc3(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_freegamesitemdesc3(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_freegamesitemdesc3(inputs)
	return ko_nav_freegamesitemdesc3(inputs)
});
export { nav_freegamesitemdesc3 as "nav.freeGamesItemDesc" }